import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function ThankYouPage() {
  const { t } = useTranslation();
  const image001 = useDocImage('thank-you-page-img', 'image001.png');
  const image002 = useDocImage('thank-you-page-img', 'image002.png');
  const image003 = useDocImage('thank-you-page-img', 'image003.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.thankYouPage.title')}</h1>
              <p className='header-para'>{t('documentation.thankYouPage.intro')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.thankYouPage.accessing.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>{t('documentation.thankYouPage.accessing.steps.step1')}
                      <img src={image003} alt={t('documentation.thankYouPage.accessing.imageAlt1')} className='img-fluid pb-20 pt-20' />
                    </li>
                    <li>{t('documentation.thankYouPage.accessing.steps.step2')} <br />
                      <img src={image001} alt={t('documentation.thankYouPage.accessing.imageAlt2')} className='pb-20 pt-20 mt-1' />
                    </li>

                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.thankYouPage.keyElements.title')}
                </div>
                <div className="card-body">
                  <img src={image002} alt={t('documentation.thankYouPage.keyElements.imageAlt')} className='pt-20 pb-30' />
                  <p><b>{t('documentation.thankYouPage.keyElements.pageHeading.title')}</b></p>
                  <ul>
                    <li>{t('documentation.thankYouPage.keyElements.pageHeading.items.item1')}</li>
                    <li>{t('documentation.thankYouPage.keyElements.pageHeading.items.item2')}</li>
                  </ul>

                  <p><b>{t('documentation.thankYouPage.keyElements.pageDescription.title')}</b></p>
                  <ul>
                    <li>{t('documentation.thankYouPage.keyElements.pageDescription.items.item1')}</li>
                    <li>{t('documentation.thankYouPage.keyElements.pageDescription.items.item2')}</li>
                  </ul>

                  <p><b>{t('documentation.thankYouPage.keyElements.buttons.title')}</b></p>
                  <ul>
                    <li>{t('documentation.thankYouPage.keyElements.buttons.items.item1')}</li>
                    <li>{t('documentation.thankYouPage.keyElements.buttons.items.item2')}</li>
                  </ul>

                  <p><b>{t('documentation.thankYouPage.keyElements.saveButton.title')}</b></p>
                  <ul>
                    <li>{t('documentation.thankYouPage.keyElements.saveButton.items.item1')}</li>
                  </ul>
                  <p>{t('documentation.thankYouPage.keyElements.conclusion')}</p>
                </div>
              </div>



            </div>
          </div>

        </div>
      </div>
    </>
  )
}
